module.exports = __webpack_public_path__ + "assets/1614c3d19b53e7c2757ccdece61cb4c2.png";